<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Digital Tranformation Through Table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <div class="col-sm-6">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari"
                name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari"
                @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="col-sm-6">
            <!-- Button to open the modal -->
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add Data
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Title
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                File
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Direction
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.title }}</td>
              <td class="text-center">
                <img :src="item.file" alt="Banner Image" style="width: 100px; height: auto;" />
              </td>
              <td>{{ item.direction }}</td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i
                    class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i
                    class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">Add New data</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit data</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required>
                </div>
                <div class="mb-3">
                  <label for="direction" class="form-label">Direction</label>
                  <input type="text" class="form-control" v-model="formData.direction" id="direction" required>
                </div>
                <div class="mb-3">
                  <label for="file" class="form-label">File</label>
                  <input type="file" class="form-control" @change="handleFileUpload" :required="method == 'add'"
                    accept="image/*">
                  <div v-if="logoPreview" class="m-4">
                    <img :src="logoPreview" alt="" srcset="" style="max-height: 100px" />
                  </div>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  data() {
    return {
      digitalList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage: 10,
      sortOrder: 'asc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        title: '',
        file: null,
        pages: 'all'
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      pages: 'all',
      logoPreview: null
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchdigitalList();
  },
  computed: {
    totalItems() {
      return this.digitalList.length;
    },
    paginatedData() {
      return this.digitalList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchdigitalList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/digital_transformation",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
          pages: this.pages
        },
        headers: {
          'Authorization': 'Bearer ' + access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {
          if (response.data?.message == 'success') {
            this.digitalList = response.data.data.digital_transformation_list; // Assign banner_list to local data
            this.totalPages = response.data.data.paginate // Update the total number of pages (this depends on how the API returns pagination info)
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchdigitalList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchdigitalList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchdigitalList();
    },
    updateItemsPerPage() {
      this.fetchdigitalList();
    },
    updatesoftby() {
      this.fetchdigitalList();
    },
    cari() {
      this.fetchdigitalList();
    },
    changepages() {
      this.fetchdigitalList();
    },

    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        title: '',
        file: null,
      };
      this.method = 'add';
      this.logoPreview = null;
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0]; // Capture the file
      this.logoPreview = URL.createObjectURL(event.target.files[0]);
    },
    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      const data = new FormData();
      var config = {}
      if (this.method == 'add') {
        data.append('title', this.formData.title);
        data.append('file', this.formData.file);
        data.append('direction', this.formData.direction);

        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/digital_transformation',
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        };
      } else {
        data.append('title', this.formData.title);
        data.append('file', this.formData.file);
        data.append('direction', this.formData.direction);

        config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/digital_transformation/' + this.formData.id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        }
      }

      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchdigitalList();
          if (this.method == 'add') {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err
        console.error("Error fetching data:", error);
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/digital_transformation/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchdigitalList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit(item) {
      this.formData = {
        title: item.title,
        file: null,
        id: item.id,
        direction: item.direction
      };
      this.logoPreview = item.file;

      this.showModal = true;
      this.method = 'edit';
    }

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}
</style>